<script lang="js">
import { RouterLink } from "vue-router";
import Dashboard from "../components/AppDashboard.vue";
import Finance from "../components/AppFinance.vue";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      currentComponent: "Dashboard",
      menuItems: [
      { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap" },
      { name: "Scholarships", label: "Academics", icon: "bi bi-mortarboard-fill" },
      { name: "Careers", label: "Resources", icon: "bi bi-folder-fill" },
      { name: "Finance", label: "Finance", icon: "bi bi-credit-card" }
    ]
    };
  },
  computed: {
    ...mapGetters(["getUser"]), // Access user data
    user() {
      return this.getUser;
    },
  },
  methods: {
    isActive(component) {
      return this.currentComponent === component ? "active" : "";
    },
    logout() {
      Swal.fire({
        title: "Are you sure?",
        text: "You will be logged out!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Logout",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.commit("logout");


          // localStorage.removeItem("user");
          console.log("User logged out");

          Swal.fire("Logged Out!", "You have been successfully logged out.", "success");
          this.$router.push("/app/auth"); // Redirect to login
        }
      });
    },
  },
  components: {
    RouterLink,
    Dashboard,
    Finance,
  },
};
</script>

<template>
  <div class="vh-100 d-flex flex-column">
    <!-- Top Navbar -->
    <nav
      class="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm py-0"
      style="background-color: #181c1f !important"
    >
      <div class="container-fluid px-0">
        <RouterLink class="navbar-brand d-flex align-items-center gap-2" to="">
          <img
            src="../assets/logo.png"
            alt="Logo"
            width="56.26"
            height="40"
            class="d-inline-block align-middle"
          />
          <h6 class="fw-bold text-uppercase m-0">First City Polytechnic</h6>
        </RouterLink>

        <div
          class="bg-info p-2 flex-grow-1 align-self-stretch"
          style="background-color: #212529 !important"
        ></div>

        <!-- Right Section: Notification, Profile, Logout -->
        <div class="d-flex align-items-center bg-secondary">
          <!-- Notification Icon with Badge -->
          <button type="button" class="btn mx-2">
            <i class="bi bi-bell position-relative fs-5 text-white">
              <span
                class="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-danger"
                >9<span class="visually-hidden">unread messages</span>
              </span>
            </i>
          </button>

          <!-- Profile Picture & Welcome Message -->
          <div class="navbar-dark d-flex align-items-center px-3 py-2 bg-dark">
            <img
              src="https://fakeimg.pl/400x400/909090/ccc8c8?text=img&font=bebas"
              alt="User"
              width="40"
              height="40"
              class="me-2 rounded-circle border border-white"
            />
            <span class="text-white" v-if="user"
              >Welcome, {{ user.firstname }}</span
            >
            <a class="btn btn-link text-white ms-3" @click="logout">
              <i class="bi bi-box-arrow-right fs-5"></i>
            </a>
          </div>
        </div>

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasSidebar"
          aria-controls="offcanvasSidebar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>

    <!-- Main Layout (Sidebar + Content) -->
    <div class="container-fluid d-flex flex-grow-1 bg-body-tertiary">
      <div class="row flex-grow-1 w-100">
        <!-- Sidebar -->
        <div
          class="col-lg-1 d-none d-lg-flex flex-column border-end h-100 px-0"
        >
          <div class="sidebar d-flex flex-column align-items-center w-100">
            <ul class="nav flex-column w-100 gap-4">
              <li
                v-for="item in menuItems"
                :key="item.name"
                class="nav-item w-100 p-3"
                :class="isActive(item.name)"
              >
                <a
                  class="nav-link d-flex flex-column align-items-center text-dark"
                  @click="currentComponent = item.name"
                >
                  <i :class="item.icon + ' fs-4'"></i>
                  <span class="small">{{ item.label }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Main Content -->
        <div class="col d-flex flex-column h-100">
          <component :is="currentComponent" class="flex-grow-1"></component>
        </div>
      </div>
    </div>

    <!-- Offcanvas sidebar for mobile -->
    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      id="offcanvasSidebar"
      aria-labelledby="offcanvasSidebarLabel"
    >
      <div class="offcanvas-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a
              class="nav-link d-flex align-items-center justify-content-center"
              href="#"
              @click="currentComponent = 'Dashboard'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-house-door me-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4z"
                />
              </svg>
              Dashboard</a
            >
          </li>
          <li class="nav-item">
            <a
              href="#"
              class="nav-link d-flex align-items-center justify-content-center"
              @click="currentComponent = 'Scholarships'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-archive me-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5zm13-3H1v2h14zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
                />
              </svg>
              Scholarship Applications
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link d-flex align-items-center justify-content-center"
              href="#"
              @click="currentComponent = 'Settings'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-gear me-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"
                />
                <path
                  d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"
                />
              </svg>
              Settings</a
            >
          </li>
          <li class="nav-item">
            <button
              @click="logout"
              class="nav-link d-inline-flex align-items-center justify-content-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-box-arrow-in-right me-2"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                />
              </svg>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sidebar ul li.active {
  color: #fff !important;
  background-color: #181c1f !important;
}

.sidebar ul li.active i,
.sidebar ul li.active span {
  color: #fff !important;
}
</style>
